import React, { useEffect, useState } from "react";
import axiosInstance from "../request";
import { URL } from "../api";

const LoginFeeMaster = () => {
  const [loginFees, setLoginFees] = useState([]);

  // Fetch Login Fee Master
  const fetchLoginFees = async () => {
    try {
      const res = await axiosInstance.get(URL.LOGIN_FEE_MASTER);
      setLoginFees(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Error fetching login fee master:", err);
    }
  };

  useEffect(() => {
    fetchLoginFees();
  }, []);

  // Enable / Disable
  const updateStatus = async (id, status) => {
    try {
      await axiosInstance.put(
        `${URL.LOGIN_FEE_STATUS}?id=${id}&status=${status}`
      );

      fetchLoginFees();
    } catch (err) {
      console.error("Error updating status:", err);
    }
  };

  return (
    <div className="container mt-4">
      <h3 className="mb-4">Login Fee Master</h3>

      <div className="table-responsive">
        <table className="table table-bordered table-hover align-middle">
          <thead className="table-dark">
            <tr>
              <th>S.No.</th>
              <th>ID</th>
              <th>Login Fee</th>
              <th>Currency</th>
              <th>Current Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {loginFees.length > 0 ? (
              loginFees.map((row, index) => (
                <tr key={row.id}>
                  <td>{index + 1}</td>

                  <td>{row.id}</td>

                  <td>₹ {row.loginFee}</td>

                  <td>{row.currency}</td>

                  <td>
                    <span
                      className={`badge ${
                        row.enabled ? "bg-success" : "bg-danger"
                      }`}
                    >
                      {row.enabled ? "Enabled" : "Disabled"}
                    </span>
                  </td>

                  <td style={{ width: "180px" }}>
                    <select
                      className="form-select form-select-sm"
                      value={row.enabled ? "ENABLE" : "DISABLE"}
                      onChange={(e) =>
                        updateStatus(row.id, e.target.value)
                      }
                    >
                      <option value="ENABLE">Enable</option>
                      <option value="DISABLE">Disable</option>
                    </select>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center">
                  No Login Fee Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LoginFeeMaster;